window.verifyCode = function verifyCode(e) {
  if (e && typeof e !== "object") {
    return new TypeError("Param `options` is not a object");
  }
  e = e || {};
  e.width = e.width || 90;
  e.height = e.height || 30;
  e.baseBackgroundColor = e.baseBackgroundColor || "#fff";
  e.codeLength = e.codeLength || 4;
  var g = function (a, b) {
    return a + Math.random() * (b - a);
  };
  var h = function (a, b) {
    return Math.floor(Math.random() * (b - a)) + a;
  };
  var k = "abcdefghjkmnpqrstuvwxyzABCDEFGHJKLMNPRSTUVWXYZ23456789".split("");
  var l = "";
  var m = document.createElement("canvas");
  m.width = e.width;
  m.height = e.height;
  var n = m.getContext("2d");
  n.fillStyle = e.baseBackgroundColor;
  n.fillRect(0, 0, e.width, e.height);
  n.globalAlpha = 0.8;
  n.font = "15px sans-serif";
  for (var i = 0; i < 10; i++) {
    n.fillStyle = "rgb(" + h(160, 230) + "," + h(160, 230) + "," + h(160, 230) + ")";
    for (var j = 0; j < 5; j++) {
      n.fillText(k[h(0, k.length)], g(-10, e.width + 10), g(-10, e.height + 10));
    }
  }
  var o = "rgb(" + h(0, 120) + "," + h(0, 120) + "," + h(0, 120) + ")";
  n.font = "bold 30px sans-serif";
  for (var i = 0; i < e.codeLength; i++) {
    var j = h(0, k.length);
    n.fillStyle = o;
    n.fillText(k[j], 5 + i * 23, 25);
    var a = g(0.85, 1.0);
    var b = g(-0.04, 0);
    var c = g(-0.3, 0.3);
    var d = g(0.85, 1.0);
    n.transform(a, b, c, d, 0, 0);
    l += k[j];
  }
  n.beginPath();
  n.strokeStyle = o;
  var A = g(10, e.height / 2);
  var b = g(e.height / 4, (3 * e.height) / 4);
  var f = g(e.height / 4, (3 * e.height) / 4);
  var T = g(e.height * 1.5, e.width);
  var w = (2 * Math.PI) / T;
  var S = function (x) {
    return A * Math.sin(w * x + f) + b;
  };
  n.linewidth = 5;
  for (var x = -20; x < 200; x += 4) {
    n.moveTo(x, S(x));
    n.lineTo(x + 3, S(x + 3));
  }
  n.closePath();
  n.stroke();
  return { code: l, dataURL: m.toDataURL() };
};
